class CartCount extends HTMLElement {
  constructor() {
    super();

    const setCount = (count) => {
      this.innerHTML = `
      <span aria-hidden="true">${count > 0 ? count : 0}</span>
      <span class="visually-hidden">${
        count === 1
          ? this.dataset.one
          : this.dataset.other.replace("[count]", count)
      }</span>`;

      this.style.display = count > 0 ? null : "none";
    };

    document.addEventListener("updateCart", (e) => {
      const cart = e.detail.cart;
      const filteredCount = cart.items
        ? cart.items.reduce((sum, item) => {
            const props = item.properties || {};
            return props["_handling-fee"] ? sum : sum + item.quantity;
          }, 0)
        : cart.item_count;
      setCount(filteredCount);
    });
  }
}

if (!customElements.get("cart-count")) {
  customElements.define("cart-count", CartCount);
}
